// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2YE9e","checkboxCol":"Table_checkboxCol__1_vmj","emailCol":"Table_emailCol__3cxsZ","actionCol":"Table_actionCol__1f46i"};